import { render, staticRenderFns } from "./orderSource.vue?vue&type=template&id=71bd892c&scoped=true&"
import script from "./orderSource.vue?vue&type=script&lang=js&"
export * from "./orderSource.vue?vue&type=script&lang=js&"
import style0 from "./orderSource.vue?vue&type=style&index=0&id=71bd892c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71bd892c",
  null
  
)

export default component.exports